<template>
  <div :class="$style.base">
    <div :class="$style.heading">
      <BaseHeading size="s">{{ heading }}</BaseHeading>
    </div>
    <slot />
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  heading: string;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  &:not(:first-child) {
    margin-top: $spacing * 0.5;
    padding-top: $spacing * 0.5;
    border-top: 1px solid var(--color-border);
  }
}
.heading {
  padding: $spacing * 0.5;
}
</style>
